import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CategoryResource } from "../../Resources";
import { Pagination } from "../utils/paginate";
import { TitledContent } from "../layout";
import { Actions } from "../utils/actions";
import { Hide } from "../utils/hide";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Create from "./create";
import Edit from "./edit";
import { ShowAlert } from "../utils/alerts";

const View = ({ parent_id, picker }) => {
    const params = useParams();
    const [add, setAdd] = useState(true);
    const [parent, setParent] = useState({ id: parent_id ?? params.parent_id });
    const [items, setItems] = useState([]);
    const [criteria, setCriteria] = useState({ page: 1, page_size: 10, parent_id: parent.id });
    // const flash = useFlashAlert();
    useEffect(() => {
        CategoryResource.get(parent.id, (resp) => {
            if (resp.status) setParent(resp.body);
        });
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        loadList();
        // eslint-disable-next-line
    }, [criteria.page]);
    useEffect(() => {
        setPage(1);
        // eslint-disable-next-line
    }, [criteria.page_size]);

    const loadList = () => {
        CategoryResource.list(criteria, (resp) => {
            if (resp.status) {
                setItems(resp.body.items);
                setCriteria(values => ({ ...values, count: resp.body.count }));
                setCriteria(values => ({ ...values, pages: Math.ceil(resp.body.count / criteria.page_size) }));
            }
        });
    };
    const setPage = (page) => setCriteria(values => ({ ...values, page: page }));
    const handleCriteria = (e) => {
        const n = e.target.name;
        const v = e.target.value;
        setCriteria(values => ({ ...values, [n]: v }));
    }

    const actions = () => {
        return {
            back: null,
            refresh: loadList,
            create: () => setAdd(!add),
        }
    }
    return (<TitledContent title={parent.name} actions={<Actions mod="user" iconOnly="true" actions={actions()} />}>
        <div className="row">
            <div className="col-12 mb-2">
                <div className="card shadow">
                    <div className="card-header py-3">
                        <div className="row">
                            <div className="col-sm-5 col-md-4 col-lg-3 col-xl-2 text-nowrap">
                                <div className="input-group">
                                    <span className="input-group-text">Show</span>
                                    <select onChange={handleCriteria} value={criteria.page_size} name={"page_size"} className="d-inline-block form-select form-select-sm">
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-body">
                        <Hide state={add}>
                            <Create parent={parent} close={() => setAdd(!add)} />
                        </Hide>
                        {(items || []).map(item => <CategoryNode key={item.id} rdata={item} picker={picker} parent_reload={loadList} />)}
                        <div className="row">
                            <div className="col-12 text-end">
                                <p>Showing {((criteria.page - 1) * criteria.page_size) + 1} to {((criteria.page - 1) * criteria.page_size) + items.length} of {criteria.count}</p>
                            </div>
                            <div className="col text-end">
                                <Pagination page={criteria.page} size={criteria.pages} goto={setPage} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </TitledContent>);
}

const CategoryNode = ({ rdata, picker, parent_reload }) => {
    const [data, setData] = useState(rdata);
    const [add, setAdd] = useState(true);
    const [edit, setEdit] = useState(false);
    const [open, setOpen] = useState(false);
    const [items, setItems] = useState([]);
    const [alert, setAlert] = useState({});

    const chevron = () => {
        if (open) return <FontAwesomeIcon icon={["fas", "fa-chevron-down"]} />;
        return <FontAwesomeIcon icon={["fas", "fa-chevron-right"]} />;
    }
    const openAct = () => {
        if (open) return setOpen(false);//close when open
        setOpen(true);
        loadList();
        return
    }
    const loadList = () => {
        CategoryResource.list({ page: 1, page_size: 1000, parent_id: data.id }, (resp) => {
            if (resp.status) {
                setItems(resp.body.items);
            }
        });
    }
    const refresh = () => {
        CategoryResource.get(data.id, (resp) => {
            if (resp.status) {
                setData(resp.body);
                loadList();
                setAdd(true);
                setEdit(false);
            }
        });
    }

    const actions = () => {
        return {
            back: null,
            refresh: null,
            create: () => setAdd(!add),
            edit: () => setEdit(!edit),
            delete: () => {
                CategoryResource.delete(data, (r) => {
                    if (r.status && parent_reload) parent_reload();
                    setAlert(r?.body);
                })
            },
        }
    }
    if (edit) {
        return <Edit rdata={data} close={refresh} />
    }
    return (
        <div className="card border-0">
            <div className="card-header py-3">
                <div className="row">
                    <div className="col-12 col-lg-9">
                        <Hide state={data.cnt === 0}>
                            <button onClick={() => openAct()} className="btn btn-sm float-start" type="button">
                                {chevron()}
                            </button>
                        </Hide>
                        <span className="badge rounded-pill bg-dark float-end">{data.cnt}</span>
                        <span>{data.title}</span>
                        <ShowAlert alerts={alert} tag="error" />
                    </div>
                    <div className="col text-end">
                        <Actions mod="user" iconOnly="true" actions={actions()}>
                            <Hide state={typeof picker == 'undefined'}>
                                <button onClick={() => picker(data)} className={`btn btn-secondary`} type="button">
                                    <i className="fas fa-magic"></i>
                                </button>
                            </Hide>
                        </Actions>
                    </div>
                </div>
            </div>
            <div className="card-body p-0 ps-2">
                <Hide state={add}>
                    <Create parent={data} close={refresh} />
                </Hide>
                <Hide state={!open}>
                    <Hide state={(items.length > 0)}>
                        <h3>Loading...</h3>
                    </Hide>
                    {items.map(dt => <CategoryNode key={dt.id} rdata={dt} picker={picker} parent_reload={refresh} />)}
                </Hide>
            </div>
        </div>
    );
}

export default View;